<template>
  <div>
    <div class="loader-fullscreen card" v-if="!user.role">
      <div class="card-body">
        <LoaderRelative />
        <div class="loader-messages">
          <span v-if="!addressBookReady && !chatReady">Lade Chat</span>
          <span v-if="!addressBookReady && chatReady">Lade Adressbuch</span>
          <span v-if="addressBookReady && chatReady">Erstelle Ansicht</span>
        </div>
      </div>
    </div>
    <b-modal id="select-sub-modal" hide-footer>
      <div class="select-sub-container">
        <div
          class="select-sub"
          v-for="admin in filteredSubscribers"
          :key="`select-sub-${admin.id}`"
          @click="assignUserToDialogue(admin.id, currentChat.chat.chat_id)"
        >
          {{ admin.first_name }} {{ admin.last_name }}
        </div>
      </div>
      <template v-slot:modal-header>
        <div class="container">
          <div class="row">
            <h5 class="chat-moderator-headline infra-blue">Subscriber hinzufügen</h5>
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal id="remove-sub-modal" hide-footer>
      <div class="remove-sub-container">
        <div
          class="remove-sub"
          v-for="admin in assignedSubscribers"
          :key="`remove-sub-${admin.id}`"
          @click="removeUserFromDialogue(admin.id, currentChat.chat.chat_id)"
        >
          {{ admin.first_name }} {{ admin.last_name }}
        </div> 
      </div>
      <template v-slot:modal-header>
        <div class="container">
          <div class="row">
            <h5 class="chat-moderator-headline infra-blue">Subscriber entfernen</h5>
          </div>
        </div>
      </template>
    </b-modal>
    <transition
      :enter-active-class="animations.standard.enter"
      :leave-active-class="animations.standard.leave"
      :name="animations.standard.name"
    >
      <div class="row" v-if="ready">
        <div class="col call-chat-sidebar">
          <div class="card">
            <div class="card-body chat-body">
              <div class="chat-box">
                <!-- Chat left side Start-->
                <div class="chat-left-aside chat-menu custom-scrollbar first_chatbar">
                  <div class="headline-moderator-dialogues"><h6>Kundendialoge</h6></div>
                  <div class="search-container">
                    Suche: <input type="text" v-model="filterDialoguesInput" />
                  </div>
                  <div class="people-list custom-scrollbar" id="people-list">
                    <ul class="list pointer" v-if="filteredDialogues.length">
                      <li
                        class="clearfix chatboxcon"
                        v-for="(chat, idx) in filteredDialogues"
                        :key="idx"
                        @click="selectCurrentChat(chat.chat_id)"
                      >
                        <div v-if="chat !== undefined" class="userBoxCon">
                          <div class="seenByIcon" v-if="!checkIfSeen(chat)">
                            <feather type="alert-circle" class="infra-blue"></feather>
                          </div>
                          <div class="userBox" v-if="chat.kunde != null">
                            <img
                              class="rounded-circle user-image"
                              :src="getAvatar(chat.kunde.id)"
                              alt
                            />
                            <div class="about">
                              <div class="name">{{ chat.kunde.first_name }} {{ chat.kunde.last_name }}</div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- Chat left side Ends-->
              </div>
            </div>
          </div>
        </div>
        <div class="col call-chat-body">
          <div class="chat empty-chat-msg" v-if="!currentChat.active">
            Kein Dialog ausgewählt
          </div>
          <div class="card" v-if="currentChat.active">
            <div class="card-body p-0">
              <div class="row chat-box">
                <!-- Chat right side start-->
                <div class="col pr-0 chat-right-aside">
                  <!-- chat start-->
                  <div class="chat">
                    <!-- chat-header start-->
                    <div class="chat-header clearfix">
                      <div class="chat-header-avatars">
                        <div
                          v-for="(recipient, idx) in currentChat.chat.recipients"
                          :key="idx"
                          class="chat-header-avatar"
                        >
                          <img class="rounded-circle" :src="getAvatar(recipient)" alt />
                          <div class="about">
                            <div class="name">
                              {{ getName(recipient) }}
                              <!--<span class="font-primary f-12">Typing...</span>-->
                            </div>
                            <div class="status digits">{{ getRole(recipient) }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="moderator-buttons">
                        <div
                          class="add-subscriber-btn infra-blue moderator-btn"
                          @click="showSubscriberModal('select-sub-modal')"
                        >
                          <feather
                            type="plus"
                            size="40"
                            class="moderator-btn-icon"
                          ></feather>
                        </div>
                        <div
                          class="remove-subscriber-btn infra-blue moderator-btn"
                          @click="showSubscriberModal('remove-sub-modal')"
                          v-if="assignedSubscribers.length"
                        >
                          <feather
                            type="minus"
                            size="40"
                            class="moderator-btn-icon"
                          ></feather>
                        </div>
                      </div>
                    </div>
                    <!-- chat-header end-->
                    <div
                      class="chat-history chat-msg-box custom-scrollbar"
                      ref="current_chat_container"
                      @scroll="loadMoreScroll"
                    >
                      <loaderRelative class="load-more-loader" v-if="loadingMore" />
                      <ul v-if="currentMessagesLoaded">
                        <li
                          v-for="(message, idx) in currentMessages"
                          :key="idx"
                          :class="{ clearfix: message.sender != user.id }"
                        >
                          <div
                            class="message"
                            :class="{
                              'my-message': message.sender == user.id,
                              'other-message': message.sender != user.id,
                              'pull-right': message.sender != user.id,
                            }"
                          >
                            <img
                              class="rounded-circle float-left chat-user-img img-30"
                              v-if="message.sender == user.id"
                              :src="getAvatar(user.id)"
                              alt
                            />
                            <img
                              class="rounded-circle float-right chat-user-img img-30"
                              v-if="message.sender != user.id"
                              :src="getAvatar(message.sender)"
                              alt
                            />
                            <div class="message-data">
                              <span class="message-data-time">{{
                                transformDate(message.created_on)
                              }}</span>
                            </div>
                            {{ message.message }}
                          </div>
                        </li>
                        <div>
                          <div class="image-not-found">
                            <div class="d-block start-conversion">
                              <img class="img-fluid" />
                            </div>
                          </div>
                        </div>
                      </ul>
                    </div>
                    <!-- end chat-history-->
                    <div class="chat-message clearfix">
                      <div class="row">
                        <div class="col-xl-12 d-flex">
                          <div class="input-group text-box text-with-loader">
                            <textarea
                              class="form-control input-txt-bx"
                              id="message-to-send"
                              type="text"
                              name="message-to-send"
                              placeholder="Nachricht schreiben..."
                              v-model="currentChat.newMessage"
                              @focus="scrollToBottom"
                              v-focus                              
                              :disabled="currentChat.updating"
                              autocomplete="off"
                            />
                            <div class="loader-container">
                              <Loader v-if="currentChat.updating" size="30" />
                            </div>
                            <div class="input-group-append">
                              <button
                                ref="sendButton"
                                class="btn btn-primary"
                                type="button"
                                @click="sendMessage()"
                              >
                                Senden
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end chat-message-->
                    <!-- Chat right side-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader.vue";
import LoaderRelative from "@/components/LoaderRelative.vue";


export default {
  name: "chat_moderator",
  data() {
    return {
      filterDialoguesInput: "",
      filtering: false,
      selectedSubscribers: [],
      ready: false,
      themenOfUser: [],
      allUsers: [],
      otherDialogues: [],
      currentChat: {
        chatMe: false,
        chat: false,
        updating: false,
        active: false,
        newMessage: "",
      },
      chatRefresh: null,
      currentMessagesLoaded: false,
      currentMessages: [],
      loadedMessagesByChat: [],
      lockRefresh: false,
      loadingMore: false,
      tabindex: 0,
      offSetBase: 5,
      addressExclusionList: [1, 81, 113, 122, 227, 226],
    };
  },
  components: {
    Loader,
    LoaderRelative,
  },
  async updated() {
    await this.$store.dispatch("images/loadImageBatch", this.$refs);
    await this.$store.dispatch("images/insertImageURLs", this.$refs);
  },
  computed: {
    ...mapGetters({
      animations: "app/animations",
      user: "auth/user",
      userImg: "auth/userImg",
      toasts: "app/toasts",
      chatActive: "chat/chatActive",
      chatReady: "chat/chatReady",
      activeChats: "chat/activeChats",
      activeChatUsers: "chat/activeChatUsers",
      userAddressBook: "chat/userAddressBook",
      avatars: "chat/avatars",
      addressBookReady: "chat/addressBookReady",
      dialogues: "chat/dialogues",
      isAdmin: "auth/isAdmin",
      unseen: "chat/unseenMessages",
      themen: "app/themen",
      admins: "chat/admins",
    }),
    filteredDialogues: function () {
      let result = this.activeChats;
      
      if (this.filterDialoguesInput == "") {
        return result.sort(this.sortBySeenBy)
      }
      result =  this.activeChats.filter((ac) => {
        const kundeName = `${ac.kunde.first_name} ${ac.kunde.last_name}`; 
        return kundeName.toLowerCase().includes(this.filterDialoguesInput.toLowerCase())
      }
      );
      console.log(result[0]);
      return result.sort(this.sortBySeenBy);
    },
    filteredSubscribers: function () {
      if (!this.currentChat.chat) return;
      return this.admins.filter((adm) => {
        return this.currentChat.chat.recipients.find((rcp) => rcp == adm.id) == undefined;
      });
    },
    assignedSubscribers: function () {
      if (!this.currentChat.chat) return;
      return this.admins.filter((adm) => {
        return this.currentChat.chat.recipients.find((rcp) => rcp == adm.id) != undefined;
      });
    },
  },
  async created() {
    if (!this.themen) await this.$store.dispatch("app/apiGetThemen");
    if (!this.activeChats.length && !this.chatReady) {
      try {
        await this.$store.dispatch("chat/initChat");
      } catch (error) {
        console.log(error);
        this.$toasted.show(
          "Fehler beim initialisieren des Chat Systems.",
          this.toasts.failure
        );
      }
    }

    try {
      await this.$store.dispatch("chat/buildUserAddressBook");
      this.allUsers = [...this.userAddressBook.kunden, ...this.userAddressBook.infrabau];
    } catch (error) {
      console.log(error);
      this.$toasted.show("Fehler beim Laden des Addressbuchs", this.toasts.failure);
    }

    await this.$store.dispatch("chat/getAdminSubscribers");
    this.ready = true;
  },
  watch: {
    activeChats: function () {
      if (this.currentChat.chat == undefined) return;
      this.refreshCurrentChat();
    },
  },
  methods: {
    async showSubscriberModal(modal) {
      if (!this.admins.length) await this.$store.dispatch("chat/getAdminSubscribers");
      this.$bvModal.show(modal);
    },
    hideSubscriberModal(modal) {
      this.$bvModal.hide(modal);
    },
    loadMoreScroll(evt) {
      if (evt.target.scrollTop == 0) {
        this.loadMoreCurrentChatMessages();
      }
    },
    checkIfSeen(chat) {
      if (!chat.seenby) return true;
      const seenBy = JSON.parse(chat.seenby);
      const result = seenBy.find((c) => c == this.user.id);
      return result;
    },
    isCustomer(usr) {
      const user = this.allUsers.find((u) => u.id == usr);
      return user.role == 'f0995ff3-21fd-41a8-91fa-551469b0c5a6';
    },
    getName(id, shorten = false) {
      if (!this.allUsers.length) return;
      const user = this.allUsers.find((u) => u.id == id);
      if(user != undefined) {
        const str = `${user.first_name} ${user.last_name}`;
        const formattedName = shorten ? str.substring(0, 20) : str;
        return formattedName;
      } else return;
    },
    getAvatar(id) {
      
      const user = this.avatars.find((a) => a.usr_id == id);
      if (!user) return;
      return user.avatar.url;
    },
    getLastMessage(chatId, userId) {
      const theChat = this.activeChats.find((c) => c.chat_id == chatId);
      if (undefined == theChat) return;
      const lastMessage = theChat.messages.filter((m) => m.sender == userId);
      lastMessage.reverse();
      if (undefined !== lastMessage && lastMessage.length > 0)
        return lastMessage[0].message.substring(0, 20) + "..";
    },
    isActive(id) {
      const res = this.activeChatUsers.find((cu) => cu.usr_id == id) == undefined;
      return res;
    },
    isChatUser(id) {
      return this.addressExclusionList.indexOf(id) > -1 ? false : true;
    },
    sortBySeenBy(a, b) {
      const aSeen = this.checkIfSeen(a);
      const bSeen = this.checkIfSeen(b);

      if(aSeen !== undefined && bSeen === undefined) return 1;
      if(bSeen !== undefined && bSeen !== undefined) return -1;
      return 0;

    },  
    async selectCurrentChat(chatId) {
      const chat = this.activeChats.find((ac) => ac.chat_id == chatId);
      this.currentChat.chatMe = this.user;
      this.currentChat.chat = chat;
      this.currentChat.active = true;
      this.currentChat.newMessage = "";
      const dialogue = this.dialogues.find((d) => d.id == chatId);
      const seenBy = dialogue.seenby ? JSON.parse(dialogue.seenby) : [];
      const isAlreadySeen = seenBy.find((s) => s == this.user.id);
      await this.loadCurrentChatMessages();
      this.scrollToBottom();
      if (!isAlreadySeen) {
        seenBy.push(this.user.id);
        const updatePayload = {
          dialogue: chatId,
          seenby: seenBy,
        };
        this.$store.dispatch("chat/setSeenByMe", updatePayload);
      }
    },
    async loadCurrentChatMessages() {
      const messagesLoaded = this.loadedMessagesByChat.find(
        (chat) => chat.id == this.currentChat.chat.chat_id
      );

      if (!messagesLoaded) {        
        const intialOffsetMessages = this.currentChat.chat.messages.slice(
          -this.offSetBase
        );

        const loadMessages = await this.$store.dispatch(
          "chat/getMessagesOfDialogue",
          intialOffsetMessages
        );
        const newMessagesByChat = {
          id: this.currentChat.chat.chat_id,
          offSet: this.offSetBase,
          messages: loadMessages,
        };

        this.loadedMessagesByChat.push(newMessagesByChat);
        this.currentMessages = newMessagesByChat.messages;
        this.currentMessages.sort(
          (a, b) => new Date(a.created_on) - new Date(b.created_on)
        );
        this.currentMessagesLoaded = true;
      } else {
        this.currentMessages = messagesLoaded.messages;
      }
    },
    async loadNewChatMessages() {
      //check if new Messages      
      if (!this.currentChat.chat) return;

      try {
        this.lockRefresh = true;
        let currentLenLoaded = this.currentMessages.length;

        const lastLoadedMessage = currentLenLoaded ? this.currentMessages[currentLenLoaded - 1].id : 0;
        const currentLenStore = this.currentChat.chat.messages.length;
        const lastStoreMessage = this.currentChat.chat.messages[currentLenStore - 1];
        const newMessages = lastLoadedMessage != lastStoreMessage;
 
        if (newMessages) {          
          const idxLast = this.currentChat.chat.messages.indexOf(lastLoadedMessage);
          const newMessages = this.currentChat.chat.messages.slice(idxLast + 1);
          const loadNewMessages = await this.$store.dispatch(
            "chat/getMessagesOfDialogue",
            newMessages
          );
          const currentLoadedMessagesByChat = this.loadedMessagesByChat.find(
            (chat) => chat.id == this.currentChat.chat.chat_id
          );
          currentLoadedMessagesByChat.messages.unshift(...loadNewMessages);
          currentLoadedMessagesByChat.messages.sort(
            (a, b) => new Date(a.created_on) - new Date(b.created_on)
          );
          this.scrollToBottom();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.lockRefresh = false;
      }
    },
    async loadMoreCurrentChatMessages() {
      const loadedChatMessages = this.loadedMessagesByChat.find(
        (chat) => chat.id == this.currentChat.chat.chat_id
      );
      this.loadingMore = true;
      //bail if all are loaded
      if (this.currentChat.chat.messages.length <= this.currentMessages.length) {
        this.loadingMore = false;
        return;
      }

      if (
        this.currentChat.chat.messages.length <
        loadedChatMessages.messages.length +
          (loadedChatMessages.messages.offSet + this.offsetBase)
      ) {
        const newOffSet = this.offsetBase + loadedChatMessages.offSet;
        const newOffsetMessages = this.currentChat.chat.messages.slice(
          -newOffSet,
          loadedChatMessages.length - 1
        );
        const loadNewMessages = await this.$store.dispatch(
          "chat/getMessagesOfDialogue",
          newOffsetMessages
        );
        loadedChatMessages.messages.unshift(...loadNewMessages);
        loadedChatMessages.offSet = newOffSet;
      } else {
        const newOffSet = this.offSetBase + loadedChatMessages.offSet;
        const start = parseInt(newOffSet);
        const end = parseInt(loadedChatMessages.offSet);
        const newOffsetMessages = this.currentChat.chat.messages.slice(-start, -end);

        const loadNewMessages = await this.$store.dispatch(
          "chat/getMessagesOfDialogue",
          newOffsetMessages
        );
        loadedChatMessages.messages.unshift(...loadNewMessages);
        loadedChatMessages.offSet = newOffSet;
      }
      this.scrollToTop();
      this.loadingMore = false;
    },
    async refreshCurrentChat() {
      const activeChat = this.activeChats.find(
        (ac) => ac.chat_id == this.currentChat.chat.chat_id
      );
      if (this.currentChat.chat.chat_id !== "NEW") this.currentChat.chat = activeChat;
      if (this.lockRefresh) return;
      await this.loadNewChatMessages();
    },
    createNewChat(rec_id) {
      this.currentChat = {
        chatMe: this.user,
        chat: {
          chat_id: "NEW",
          messages: [],
          recipients: [rec_id],
        },
        active: true,
        newMessage: "",
      };
      this.currentMessages = [];
    },
    getRole(userId) {
      const user = this.allUsers.find((u) => u.id == userId);
      if (undefined == user) return;
      if (user.role == '0ef37112-08ae-4f6a-b727-12f6b0d8b964') {
        return this.getThemenOfUser(userId);
      }
      if (user.role == 'f0995ff3-21fd-41a8-91fa-551469b0c5a6') return "Kunde";
      return "Default";
    },
    getThemenOfUser(id) {
      let result = [];
      try {
        for (let i = 0; i < this.themen.length; i++) {
          let ansp = this.themen[i].ansprechpartner;
          for (let a = 0; a < ansp.length; a++) {
            if (ansp[a].ansprechpartner_id.id == id) result.push(ansp[a].ansprechpartner_themen_id.name);
          }
        }
      } catch (error) {
        console.log(error);
        this.$toasted.show(
          "Fehler beim laden der Ansprechpartner Themen",
          this.toasts.failure
        );
      }
      if (!result.length) return "Infrabau Admin";
      return result.join(", ");
    },
    async createNewDialogue() {
      try {
        const responseDialogue = await this.$store.dispatch("chat/createDialogue");
        const relPayload = {
          chat: responseDialogue.data.id,
          recipients: [...this.currentChat.chat.recipients, this.user.id],
        };
        await this.$store.dispatch("chat/assignRecipientsToDialogue", relPayload);
        await this.$store.dispatch("chat/addDialogue", responseDialogue.data.id);
        return responseDialogue.data.id;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Erstellen des Dialogs", this.toasts.failure);
      }
    },
    async sendMessage() {
      if (!this.currentChat.newMessage.length) {
        this.$toasted.show("Nachrichtenfeld leer", this.toasts.failure);
        return;
      }
      const newChat = this.currentChat.chat.chat_id == "NEW";

      const msg = this.currentChat.newMessage;

      const currentId = newChat
        ? await this.createNewDialogue()
        : this.currentChat.chat.chat_id;

      const payload = {
        dialogueId: currentId,
        message: this.currentChat.newMessage,
        sender: this.user.id,
      };

      try {
        this.currentChat.updating = true;
        await this.$store.dispatch("chat/sendMessage", payload);
        if (newChat) this.selectCurrentChat(currentId);
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim senden der Nachricht.", this.toasts.failure);
      } finally {
        this.currentChat.updating = false;
        this.currentChat.newMessage = "";
      }

      const mailPayloadCustomer = {
          mode: "customer",
          customer: this.currentChat.chat.kunde,
          message: msg,
          recipients: [this.currentChat.chat.kunde.email]
        }
      this.$store.dispatch("chat/sendChatMail", mailPayloadCustomer);

      const subscribers = this.currentChat.chat.recipients.filter(sub => sub != this.currentChat.chat.kunde.id);
      let subEmails = [];
       
      subscribers.forEach(sub => {
        const user = this.allUsers.find(au => au.id == sub);
        subEmails.push(user.email);
      });

      const mailPayloadSubscriber = {
        mode: "subscribermsg",
        customer: this.currentChat.chat.kunde,
        message: msg,
        recipients: subEmails
      }

      if(subEmails.length) this.$store.dispatch("chat/sendChatMail", mailPayloadSubscriber);      

      this.refreshCurrentChat();
      this.scrollToBottom();
    },
    scrollToBottom() {
      const chatContainer = this.$refs.current_chat_container;
      if (undefined !== chatContainer) {
        this.$nextTick(() => {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        });
      }
    },
    scrollToTop() {
      const chatContainer = this.$refs.current_chat_container;
      if (undefined !== chatContainer) {
        this.$nextTick(() => {
          chatContainer.scrollTop = 5;
        });
      }
    },
    async selectOtherDialogue(dialogue) {
      try {
        const subPl = {
          dialog_id: dialogue.id,
          user_id: this.user.id,
        };
        await this.$store.dispatch("chat/subscribeToDialogue", subPl);
        this.tabindex = 0;
        await this.$store.dispatch("chat/getSingleDialogueData", dialogue.id);
        await this.$store.dispatch("chat/buildUserAddressBook");
        this.selectCurrentChat(dialogue.id);
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Dialog laden", this.toasts.failure);
      }
    },
    async assignUserToDialogue(user_id, dialog_id) {
      try {
        const subscribePayload = {
          dialog_id,
          user_id,
        };

        await this.$store.dispatch("chat/subscribeToDialogue", subscribePayload);
        await this.$store.dispatch("chat/getSingleDialogueData", dialog_id);
        this.hideSubscriberModal("select-sub-modal");        
      } catch (err) {
        console.log(err);
        this.$toasted.show("Fehler beim Beitreten des Dialogs", this.toasts.failure);
      }

      const msg = `Sie wurden in den Dialog mit Kunde ${this.currentChat.chat.kunde.first_name} ${this.currentChat.chat.kunde.last_name} eingebucht.`;
      const recipient = this.userAddressBook.infrabau.find(au => au.id == user_id);

        const mailPayload = {
          mode: "subscriber",
          customer: this.currentChat.chat.kunde,
          message: msg,
          recipients: [recipient.email]
        }
        this.$store.dispatch("chat/sendChatMail", mailPayload);
    },
    async removeUserFromDialogue(user_id, dialog_id) {
      try {
        const getDialoguePayload = {
          filter: {
            dialog_id: dialog_id,
            user_id: user_id
          }
        };
        const getDialogueToUnsubscribe = await this.$directus.items("dialogue_users").readByQuery(getDialoguePayload);
        await this.$store.dispatch("chat/unsubscribeToDialogue", getDialogueToUnsubscribe.data[0].id);
        this.hideSubscriberModal("remove-sub-modal");
      } catch (err) {
        console.log(err);
        this.$toasted.show("Fehler beim Verlassen des Dialogs", this.toasts.failure);
      }
    },
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus();
      },
    },
  },
  scroll: {
    inserted: function (el, binding) {
      let f = function (evt) {
        if (binding.value(evt, el)) {
          window.removeEventListener("scroll", f);
        }
      };
      window.addEventListener("scroll", f);
    },
  },
};
</script>

<style>

.message {
white-space:pre-line;
}

.select-sub,
.remove-sub {
  color: #004f7d;
  font-size: 1.1em;
  font-weight: bold;
  padding: 5px;
  cursor: pointer;
}

.select-sub:hover,
.remove-sub:hover {
  background: lightgrey;
  transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
}

.moderator-buttons {
  display: flex;
  margin-right: 20px;
}

.moderator-btn-icon {
  border: 1px solid #004f7d;
  border-radius: 75px;
  padding: 5px;
  cursor: pointer;
  margin-right: 5px;
}

.moderator-btn-icon:hover {
  color: white;
  background: #004f7d;
  transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
}

.chat-header {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-self: flex-start;
}

.chat-header-avatars {
  width: 100%;
  display: flex;
  align-items: flex-start;
}

.chat-header-avatar {
  margin-right: 20px;
}

.loader-relative.load-more-loader {
  height: 50px;
}

.name {
  font-size: 0.8em;
}

.empty-chat-msg {
  position: relative;
  vertical-align: middle;
  font-size: 25px;
  margin: auto;
  top: 25%;
  left: 25%;
}

.tab-content {
  overflow: hidden;
}

.call-chat-sidebar .chat-box .chat-menu .tab-pane {
  padding: 0px;
}

.loader-container {
  position: relative;
  right: 25px;
  z-index: 999;
  bottom: -13px;
}
.first_chatbar {
  border-left: 0px solid #f6f7fb !important;
}
</style>

<style scoped>
.font-small {
  font-size: 10px !important;
}

.loader-fullscreen {
  width: 300px;
  margin: auto;
  top: 200px;
}

.loader-messages {
  text-align: center;
}

.loader {
  backdrop-filter: none;
  background: none;
}

.dialogue_overview {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.subscriber_names {
  font-size: 0.7em;
  display: inline-block;
}

.subscriber_names div {
  margin-left: 5px;
}
</style>

<style scoped>
.seenByIcon {
  position: absolute;
  right: 10px;
}
.userBox {
  display: block;
  width: 100%;
  float: none;
  margin-bottom: 5px;
}

.userBoxCon {
  display: flex;
  flex-flow: column;
  padding: 10px;
}

.chatboxcon {
  border: 1px solid lightgrey;
  margin-bottom: 5px;
}

.search-container {
  overflow: hidden;
  margin-bottom: 10px;
  display: block;
  z-index: 999;
  background: white;
}

.headline-moderator-dialogues {
  border-bottom: 2px solid #004f7d;
  margin-bottom: 20px;
  text-align: center;
}

.search-container {
  margin-bottom: 20px;
  font-weight: bold;
}

.search-container input {
  border-radius: 10px;
  border: 1px solid lightgrey;
  padding: 2px;
}
</style>
